// rebuild trigger: 3
import "./index.css"
import { initSentry } from "../lib/observability/sentry"

// Debug: log env var presence at module load
console.log("[main] VITE_SUPABASE_URL defined:", !!import.meta.env.VITE_SUPABASE_URL)
console.log("[main] VITE_SUPABASE_PUBLISHABLE_KEY defined:", !!import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY)

initSentry()

async function bootstrap() {
  try {
    const { createRoot } = await import("react-dom/client")
    const { BrowserRouter } = await import("react-router-dom")
    const { ErrorBoundary } = await import("./components/ErrorBoundary")
    const { default: App } = await import("./App")

    createRoot(document.getElementById("root")!).render(
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    )
  } catch (err: any) {
    const root = document.getElementById("root")!
    root.innerHTML = `
      <div style="font-family:system-ui,sans-serif;padding:40px;max-width:520px;margin:80px auto">
        <h2 style="color:#dc2626;margin-bottom:12px">Application failed to start</h2>
        <p style="color:#64748b;margin-bottom:12px">The app could not initialize. This is usually caused by missing environment variables.</p>
        <pre style="background:#f1f5f9;padding:12px;border-radius:6px;font-size:13px;overflow:auto;white-space:pre-wrap">${err?.message ?? String(err)}</pre>
        <p style="margin-top:16px;color:#64748b">
          Make sure <code>VITE_SUPABASE_URL</code> and <code>VITE_SUPABASE_PUBLISHABLE_KEY</code>
          are set in your <strong>Lovable project settings → Secrets</strong>.
        </p>
        <button onclick="location.reload()" style="margin-top:16px;padding:8px 20px;background:#1e293b;color:#fff;border:none;border-radius:6px;cursor:pointer">Reload</button>
      </div>
    `
  }
}

bootstrap()
